export default __webpack_public_path__ + "static/media/telegram.0b5e0a46.svg";